import { NextApiRequest, NextApiResponse } from 'next'
import { LayoutProps, ComponentType, TeaserProps, TopTeaserListProps } from '@sport1/types/web'
import Config from '@/utils/Config'
import { getLayout } from '@/pages/api/cms/content/tag/[id]'

const index = async (req: NextApiRequest, res: NextApiResponse): Promise<void> => {
    try {
        const TopVideoListTeaserLayout = await getTopVideoListTeaserLayout()
        res.status(200).json({ success: true, data: TopVideoListTeaserLayout })
    } catch (error) {
        res.status(error.statusCode || 500).json({ success: false, ...error })
    }
}

export default index

export const getTopVideoListTeaserLayout = async (): Promise<LayoutProps | undefined> => {
    const hydrationConfig = '%7B%22contentTypes%22%3A%5B%22V%22%5D%2C%22maxElements%22%3A5%7D'
    const url = `${Config.CMS_API}/v2/de/cms/content/fragment/POPULAR_TEASER/hydrationConfig/${hydrationConfig}`
    const layout = await getLayout(url)
    return remapTopToSingleComponent(layout)
}

const remapTopToSingleComponent = (layout: LayoutProps): LayoutProps => {
    if (layout.components.length) {
        const content = layout.components.reduce<TeaserProps[]>((acc, currentComponent) => {
            if (currentComponent.type === ComponentType.TOP_TEASER_CARD) {
                acc.push(
                    ...currentComponent.content.filter(
                        (c): c is TeaserProps => c.type !== ComponentType.AD
                    ) //TopTeaserListProps shouldn't contain ads
                )
            }
            return acc
        }, [])
        const component: TopTeaserListProps = {
            ...(layout.components[0] as TopTeaserListProps),
            type: ComponentType.TOP_TEASER_LIST,
            content,
        }
        return {
            ...layout,
            components: [component],
        }
    }
    return layout
}
